import React, { PropsWithChildren } from 'react';

import CssBaseline from '@mui/material/CssBaseline';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { frFR } from '@mui/x-date-pickers/locales';

import { appTheme } from '@/theme/CreateTheme.ts';

export const MuiWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={appTheme}>
        <LocalizationProvider
          dateAdapter={AdapterLuxon}
          localeText={
            frFR.components.MuiLocalizationProvider.defaultProps.localeText
          }
        >
          <CssBaseline />
          {children}
        </LocalizationProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};
